import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ThemeContext } from 'styled-components'
import { Text } from 'rebass'
import Modal from '../../components/Modal'
import { AutoColumn } from '../../components/Column'
import { RowBetween } from '../../components/Row'
import { TYPE } from '../../theme'
import { ButtonSecondary } from '../../components/Button'
import { Input } from '../../components/NumericalInput'
import { CloseIcon } from '../../theme/components'
import { InputPanel, Container, LabelRow, InputRow, UnitLabel } from './styleds'

interface UpdatePriceModalProps {
  isOpen: boolean
  orderId: number
  currentPrice: string
  onDismiss: () => void
  onConfirm: (newPrice: string) => void
  pending: boolean
}

export default function UpdatePriceModal({
  isOpen,
  orderId,
  currentPrice,
  onDismiss,
  onConfirm,
  pending
}: UpdatePriceModalProps) {
  const { t } = useTranslation()
  const theme = useContext(ThemeContext)
  const [newPrice, setNewPrice] = useState(currentPrice)

  const handlePriceInput = (value: string) => {
    if (value === '') {
      setNewPrice('')
      return
    }
    const parts = value.split('.')
    if (parts.length === 2 && parts[1].length > 4) {
      setNewPrice(parts[0] + '.' + parts[1].slice(0, 4))
      return
    }
    setNewPrice(value)
  }

  const handleConfirm = () => {
    if (!newPrice || parseFloat(newPrice) <= 0) return
    onConfirm(newPrice)
  }

  React.useEffect(() => {
    if (isOpen) {
      setNewPrice(currentPrice)
    }
  }, [isOpen, currentPrice])

  return (
    <Modal isOpen={isOpen} onDismiss={onDismiss} maxHeight={90}>
      <div style={{ width: '100%', padding: 24 }}>
        <RowBetween>
          <Text fontWeight={500} fontSize={20}>
            {t('orderUpdatePrice')} #{orderId}
          </Text>
          <CloseIcon onClick={onDismiss} />
        </RowBetween>
        <AutoColumn gap="16px" style={{ marginTop: 20 }}>
          <InputPanel>
            <Container>
              <LabelRow>
                <RowBetween>
                  <TYPE.body color={theme.text2} fontWeight={500} fontSize={14}>
                    {t('orderNewPrice')}
                  </TYPE.body>
                </RowBetween>
              </LabelRow>
              <InputRow>
                <Input value={newPrice} onUserInput={handlePriceInput} placeholder="0.0" />
                <UnitLabel>USDT/MUD</UnitLabel>
              </InputRow>
            </Container>
          </InputPanel>

          <ButtonSecondary onClick={handleConfirm} disabled={pending || !newPrice || parseFloat(newPrice) <= 0}>
            <Text fontWeight={500} fontSize={16}>
              {pending ? t('orderUpdating') : t('orderUpdatePrice')}
            </Text>
          </ButtonSecondary>
        </AutoColumn>
      </div>
    </Modal>
  )
}
